module.exports = __webpack_public_path__ + "static/media/parallax-bg-18.a82440ba.jpg";